/** Default spotlight padding in Lattice base size scale units (x4) applied to all tours. */
export const DEFAULT_SPOTLIGHT_PADDING = 4;

/** Delay in milliseconds before a tour starts after its target element is found. */
export const TOUR_START_DELAY_MS = 500;
